import {
  CatalogRepository,
  CatalogFilterParams,
  PaginatedProductsResult,
} from '../../domain/repositories/catalog.repository';
import { ProductEntity } from '../../domain/entities/product.entity';

export class GetProductsUseCase {
  constructor(private readonly catalogRepository: CatalogRepository) {}

  async execute(params?: CatalogFilterParams): Promise<ProductEntity[]> {
    return this.catalogRepository.getProducts(params);
  }

  async executePaginated(params?: CatalogFilterParams): Promise<PaginatedProductsResult> {
    return this.catalogRepository.getProductsPaginated(params);
  }
}
